angular.module('capability-ng-global').run(function(ConsistentPageConfiguration: any) {
  ConsistentPageConfiguration.activate();
});



// WEBPACK FOOTER //
// ./app/lib/global/configuration/page.ts